const THEME_KEY = 'cbs_admin_theme'

export function applyTheme(): void {
  const stored = localStorage.getItem(THEME_KEY)
  const preferred = stored === 'light' || stored === 'dark' ? stored : 'dark'
  document.documentElement.setAttribute('data-theme', preferred)
}

export function toggleTheme(): void {
  const current = document.documentElement.getAttribute('data-theme') ?? 'dark'
  const next = current === 'dark' ? 'light' : 'dark'
  document.documentElement.setAttribute('data-theme', next)
  localStorage.setItem(THEME_KEY, next)
}

export function getTheme(): 'light' | 'dark' {
  return (document.documentElement.getAttribute('data-theme') ?? 'dark') as 'light' | 'dark'
}
